module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/236-republic-of-macedonia-2f2dc4ff33d7deb8d7a7b8ee93ee88c2.svg";